/* =============================================================
   IMPACT INSPIRED — theme.js
   ============================================================= */
(function () {
  'use strict';

  /* ---------- Helpers ---------- */
  function fetchConfig(type) {
    return {
      method: type || 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
    };
  }
  function money(cents, currency) {
    try {
      var fmt = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: currency || window.shopCurrency || 'USD'
      });
      return fmt.format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- Slideshow ---------- */
  function initSlideshows() {
    qsa('[data-slideshow]').forEach(function (root) {
      var track = qs('[data-slideshow-track]', root);
      var slides = qsa('[data-slide]', root);
      var index = 0;
      var count = slides.length;
      if (count <= 1) return;

      function go(i) {
        index = (i + count) % count;
        track.style.transform = 'translateX(' + (-index * 100) + '%)';
        slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
        qsa('[data-slideshow-dot]', root).forEach(function (d, n) { d.classList.toggle('is-active', n === index); });
      }
      qs('[data-slideshow-prev]', root).addEventListener('click', function () { go(index - 1); reset(); });
      qs('[data-slideshow-next]', root).addEventListener('click', function () { go(index + 1); reset(); });
      qsa('[data-slideshow-dot]', root).forEach(function (d) {
        d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-slideshow-dot'), 10)); reset(); });
      });

      var timer = null;
      function autoplay() {
        if (root.getAttribute('data-autoplay') !== 'true') return;
        timer = setInterval(function () { go(index + 1); }, parseInt(root.getAttribute('data-speed'), 10) || 6000);
      }
      function reset() { if (timer) clearInterval(timer); autoplay(); }
      autoplay();
    });
  }

  /* ---------- Cart drawer ---------- */
  var drawer = null, drawerBody = null, drawerFooter = null, emptyState = null, cartCountEls = null;

  function initCartDrawer() {
    drawer = qs('[data-cart-drawer]');
    if (!drawer) return;
    drawerBody = qs('[data-cart-drawer-body]', drawer);
    drawerFooter = qs('[data-cart-footer]', drawer);
    emptyState = qs('[data-cart-empty]', drawer);
    cartCountEls = qsa('[data-cart-count]');

    qs('[data-cart-drawer-close]', drawer).addEventListener('click', closeCart);
    qsa('[data-cart-toggle]').forEach(function (btn) { btn.addEventListener('click', openCart); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

    var note = qs('[data-cart-note]', drawer);
    if (note) {
      note.addEventListener('change', function () {
        fetch(window.routes.cart_update_url, Object.assign({}, fetchConfig('POST'), { body: JSON.stringify({ note: note.value }) }));
      });
    }
    renderCart(window.__initialCart || null);
  }

  function openCart() { if (drawer) { drawer.classList.add('open'); document.body.classList.add('menu-open'); var ov = qs('.overlay'); if (ov) ov.classList.add('visible'); } }
  function closeCart() { if (drawer) { drawer.classList.remove('open'); document.body.classList.remove('menu-open'); var ov = qs('.overlay'); if (ov) ov.classList.remove('visible'); } }

  function renderCart(cart) {
    if (!cart) return;
    cartCountEls.forEach(function (el) { el.textContent = cart.item_count; });
    if (!drawerBody) return;
    var items = cart.items || [];
    if (items.length === 0) {
      drawerBody.innerHTML = '';
      if (emptyState) emptyState.style.display = '';
      if (drawerFooter) drawerFooter.style.display = 'none';
      return;
    }
    if (emptyState) emptyState.style.display = 'none';
    if (drawerFooter) drawerFooter.style.display = '';
    var sub = qs('[data-cart-subtotal]', drawer);
    if (sub) sub.textContent = money(cart.total_price, cart.currency);
    drawerBody.innerHTML = items.map(function (item, i) {
      return '' +
        '<div class="drawer-item" data-line="' + (i + 1) + '">' +
          '<div class="drawer-item__media">' + (item.image ? '<img src="' + item.image + '" alt="' + (item.title || '').replace(/"/g, '') + '">' : '') + '</div>' +
          '<div class="drawer-item__info">' +
            '<div class="drawer-item__title">' + item.product_title + '</div>' +
            (item.variant_title ? '<div class="drawer-item__variant">' + item.variant_title + '</div>' : '') +
            '<div class="drawer-item__price">' + money(item.final_price, cart.currency) + '</div>' +
            '<div class="drawer-item__qty">' +
              '<button data-drawer-minus data-line="' + (i + 1) + '">&minus;</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button data-drawer-plus data-line="' + (i + 1) + '">+</button>' +
            '</div>' +
            '<button class="drawer-item__remove" data-drawer-remove data-line="' + (i + 1) + '">Remove</button>' +
          '</div>' +
        '</div>';
    }).join('');
    bindDrawerItemEvents(cart.currency);
  }

  function bindDrawerItemEvents(currency) {
    qsa('[data-drawer-plus]', drawer).forEach(function (b) {
      b.addEventListener('click', function () { changeLine(parseInt(b.getAttribute('data-line'), 10), +1, currency); });
    });
    qsa('[data-drawer-minus]', drawer).forEach(function (b) {
      b.addEventListener('click', function () { changeLine(parseInt(b.getAttribute('data-line'), 10), -1, currency); });
    });
    qsa('[data-drawer-remove]', drawer).forEach(function (b) {
      b.addEventListener('click', function () {
        var line = parseInt(b.getAttribute('data-line'), 10);
        changeQuantity(line, 0, currency);
      });
    });
  }

  function changeLine(line, delta, currency) {
    var items = qsa('.drawer-item', drawer);
    var row = items.filter(function (el) { return parseInt(el.getAttribute('data-line'), 10) === line; })[0];
    var qtyEl = row ? qs('.drawer-item__qty span', row) : null;
    var newQty = (qtyEl ? parseInt(qtyEl.textContent, 10) : 1) + delta;
    if (newQty < 1) newQty = 0;
    changeQuantity(line, newQty, currency);
  }

  function changeQuantity(line, quantity, currency) {
    fetch(window.routes.cart_change_url, Object.assign({}, fetchConfig('POST'), { body: JSON.stringify({ line: line, quantity: quantity }) }))
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); refreshPageCart(cart); })
      .catch(function () {});
  }

  function addToCart(formData) {
    var config = Object.assign({}, fetchConfig('POST'), { body: formData }); delete config.headers['Content-Type']; return fetch(window.routes.cart_add_url, config)
      .then(function (r) { return r.json(); })
      .then(function () { return fetch(window.routes.cart_url, fetchConfig('GET')).then(function (r) { return r.json(); }); })
      .then(function (cart) { renderCart(cart); refreshPageCart(cart); openCart(); return cart; });
  }

  /* ---------- Quick add (product cards) ---------- */
  function initQuickAdd() {
    qsa('[data-quick-add]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = qs('[data-quick-add-button]', form);
        if (btn) { btn.disabled = true; btn.setAttribute('data-original', btn.textContent); btn.textContent = 'Adding...'; }
        var fd = new FormData(form);
        addToCart(fd).then(function () {
          if (btn) { btn.disabled = false; btn.textContent = btn.getAttribute('data-original') || 'Add to cart'; }
        }).catch(function () { if (btn) { btn.disabled = false; btn.textContent = btn.getAttribute('data-original') || 'Add to cart'; } });
      });
    });
  }

  /* ---------- Product page ---------- */
  function initProductPage() {
    var section = qs('[data-product-section]');
    if (!section) return;
    var productData = null;
    var jsonEl = qs('[data-product-json]');
    if (jsonEl) {
      try { productData = JSON.parse(jsonEl.textContent); } catch (e) { productData = null; }
    }
    if (!productData || !productData.variants) return;

    var form = qs('[data-product-form]', section);
    var variantInput = qs('[data-variant-id]', section);
    var addBtn = qs('[data-add-button]', section);
    var addText = qs('[data-add-button-text]', section);
    var priceEl = qs('[data-price]', section);

    var selected = {};
    qsa('[data-option-button]', section).forEach(function (btn) {
      var pos = parseInt(btn.getAttribute('data-option-position'), 10);
      if (btn.classList.contains('is-selected')) selected['option' + pos] = btn.getAttribute('data-value');
    });

    function getSelectedVariant() {
      // ensure all options selected (default first if not)
      qsa('.product__option', section).forEach(function (opt, i) {
        if (!selected['option' + (i + 1)]) {
          var first = qs('[data-option-button]', opt);
          if (first) { selected['option' + (i + 1)] = first.getAttribute('data-value'); first.classList.add('is-selected'); }
        }
      });
      return productData.variants.find(function (v) {
        return v.options.every(function (val, i) { return val === selected['option' + (i + 1)] || Object.keys(selected).length === 0; });
      }) || productData.variants[0];
    }

    function update() {
      var v = getSelectedVariant();
      if (!v) {
        if (addBtn) addBtn.disabled = true;
        if (addText) addText.textContent = 'Unavailable';
        return;
      }
      if (variantInput) variantInput.value = v.id;
      if (addBtn) addBtn.disabled = !v.available;
      if (addText) addText.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (priceEl && v.price != null) {
        var html = '';
        if (v.compare_at_price && v.compare_at_price > v.price) {
          html += '<span class="product__price-sale">' + money(v.price, productData.currency) + '</span>';
          html += '<s class="product__price-compare">' + money(v.compare_at_price, productData.currency) + '</s>';
          html += '<span class="product__price-badge">On sale</span>';
        } else {
          html += '<span class="product__price-regular">' + money(v.price, productData.currency) + '</span>';
        }
        priceEl.innerHTML = html;
      }
    }

    qsa('[data-option-button]', section).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pos = parseInt(btn.getAttribute('data-option-position'), 10);
        qsa('[data-option-button]', btn.parentNode).forEach(function (s) { s.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        selected['option' + pos] = btn.getAttribute('data-value');
        update();
      });
    });

    // Quantity
    qsa('[data-quantity-plus]', section).forEach(function (b) { b.addEventListener('click', function () { var i = qs('[data-quantity-input]', section); i.value = parseInt(i.value, 10) + 1; }); });
    qsa('[data-quantity-minus]', section).forEach(function (b) { b.addEventListener('click', function () { var i = qs('[data-quantity-input]', section); i.value = Math.max(1, parseInt(i.value, 10) - 1); }); });

    // Gallery
    qsa('[data-gallery-thumb]', section).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-gallery-thumb');
        var main = qs('[data-gallery-main] img', section);
        if (main) main.src = src;
        qsa('[data-gallery-thumb]', section).forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    // Add to cart form
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn) { addBtn.disabled = true; addBtn.setAttribute('data-original', addText ? addText.textContent : ''); if (addText) addText.textContent = 'Adding...'; }
        addToCart(new FormData(form)).then(function () {
          if (addBtn) { addBtn.disabled = false; if (addText) addText.textContent = addBtn.getAttribute('data-original') || 'Add to cart'; }
        }).catch(function () { if (addBtn) { addBtn.disabled = false; if (addText) addText.textContent = addBtn.getAttribute('data-original') || 'Add to cart'; } });
      });
    }

    update();
  }

  /* ---------- Cart page (refresh support) ---------- */
  function refreshPageCart(cart) {
    var pageForm = qs('[data-cart-page-form]');
    if (pageForm) {
      // On cart page, simplest correct behaviour is to reload after changes
    }
    cartCountEls = qsa('[data-cart-count]');
    cartCountEls.forEach(function (el) { el.textContent = cart.item_count; });
    var sub = qs('[data-cart-subtotal]:not(.cart-drawer .cart-drawer__subtotal)');
    qsa('[data-cart-subtotal]').forEach(function (el) {
      if (!el.closest('.cart-drawer')) el.textContent = money(cart.total_price, cart.currency);
    });
  }

  function initCartPage() {
    var pageForm = qs('[data-cart-page-form]');
    if (!pageForm) return;
    // Quantity buttons
    qsa('[data-quantity-plus]', pageForm).forEach(function (b) {
      b.addEventListener('click', function () {
        var line = parseInt(b.getAttribute('data-line'), 10);
        var input = qs('[data-quantity-input][data-line="' + line + '"]', pageForm);
        input.value = parseInt(input.value, 10) + 1;
        updateCartPageLine(line, input.value);
      });
    });
    qsa('[data-quantity-minus]', pageForm).forEach(function (b) {
      b.addEventListener('click', function () {
        var line = parseInt(b.getAttribute('data-line'), 10);
        var input = qs('[data-quantity-input][data-line="' + line + '"]', pageForm);
        var v = Math.max(0, parseInt(input.value, 10) - 1);
        input.value = v;
        updateCartPageLine(line, v);
      });
    });
    qsa('[data-cart-remove]', pageForm).forEach(function (b) {
      b.addEventListener('click', function () {
        var line = parseInt(b.getAttribute('data-line'), 10);
        updateCartPageLine(line, 0);
      });
    });
  }

  function updateCartPageLine(line, quantity) {
    fetch(window.routes.cart_change_url, Object.assign({}, fetchConfig('POST'), { body: JSON.stringify({ line: line, quantity: quantity }) }))
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.item_count === 0) { window.location.reload(); return; }
        window.location.reload();
      });
  }

  /* ---------- Init ---------- */
  function init() {
    initSlideshows();
    initCartDrawer();
    initQuickAdd();
    initProductPage();
    initCartPage();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
